import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayerEngagementResponse,
  IPayerResponse,
  IWorkLog
} from "@wingspanhq/payments/dist/interfaces";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { DataView } from "../../../shared/components/DataView";
import { getWorkLogPayeeStatusPill } from "../utils/getWorkLogPayeeStatusPill";

type Props = {
  shimmer?: boolean;
  workLog?: IWorkLog;
  payer?: IPayerResponse;
  payerPayeeEngagement?: IPayerEngagementResponse;
};

export const WorkLogAssignmentInfoPayeeView: React.FC<Props> = props => {
  const statusPill = props.workLog
    ? getWorkLogPayeeStatusPill(props.workLog)
    : undefined;

  const names = props.payer
    ? wsName({
        user: {
          email: props.payer.user?.email as string,
          profile: props.payer.user?.profile
        },
        member: props.payer.member
      })
    : undefined;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Assignment name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            pill: statusPill,
            hideValue: true
          },
          { label: "Client name", value: names?.getResolvedName() }
        ]}
      />
    </WSElement>
  );
};
